import React from 'react';

const AboutPage = () => {
  return (
    <div className="px-8 py-20 animate-fadeIn">
      <div className="max-w-5xl mx-auto text-center">
        <h1 className="text-6xl font-bold mb-6">About DC Consulting</h1>
        <p className="text-xl text-brand-text-dark mb-12">
          We are a collective of strategists, engineers, and innovators dedicated to helping businesses harness the transformative power of Cloud and AI.
        </p>
      </div>

      <div className="max-w-5xl mx-auto bg-brand-gray p-12 rounded-xl border border-brand-light-gray mb-20">
        <h2 className="text-4xl font-bold mb-4 text-brand-primary">Our Mission</h2>
        <p className="text-lg text-brand-text-dark leading-relaxed">
          Our mission is to architect and build the intelligent, scalable, and resilient systems that will define the next era of digital innovation. We partner with our clients to not only navigate the complexities of digital transformation but to lead the charge, turning ambitious ideas into tangible, market-leading realities. We believe in building the future, one project at a time.
        </p>
      </div>
    </div>
  );
};

export default AboutPage; 